const BOOK2LOOK_DOMAIN = "harpercollins.com.au";
const MEDIA_SELECTOR = ".product__media-item-container";

function parsePubDate(data) {
  const raw = data?.date?.date;
  if (!raw) return null;
  const day = String(raw).slice(0, 10);
  const parsed = new Date(`${day}T00:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function isEbookFormat(format) {
  return format?.format_id === "DG" || format?.format?.code === "DG";
}

function isPublished(data) {
  const pubDate = parsePubDate(data);
  if (!pubDate) return true;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return pubDate.getTime() <= today.getTime();
}

function getEbookIsbn(data) {
  const formats = data?.formats;
  if (!Array.isArray(formats)) return null;

  const ebook = formats.find(isEbookFormat);
  return ebook?.isbn || null;
}

function insertBook2Look(isbn) {
  if (document.querySelector(".look-inside")) return;

  const container = document.querySelector(MEDIA_SELECTOR);
  if (!container) return;

  const div = document.createElement("div");
  div.className = "look-inside";

  const link = document.createElement("a");
  link.href = `https://www.book2look.com/embed/${isbn}(${BOOK2LOOK_DOMAIN})`;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  link.textContent = "Read a Sample";
  link.className = "btn btn--primary";

  div.appendChild(link);
  container.insertAdjacentElement("afterend", div);
}

function addRrpLabel() {
  const requiresShipping = window.productData?.variants[0]?.requires_shipping;
  if (!requiresShipping) return;

  const price = document.querySelector(".f-price-item--regular");
  if (!price || price.querySelector(".rrp-label")) return;

  const label = document.createElement("span");
  label.className = "rrp-label";
  label.textContent = "RRP: ";

  price.prepend(label);
}

function onStaticProductData(data) {
  if (!data || !isPublished(data)) return;

  const isbn = getEbookIsbn(data);
  if (!isbn) return;

  insertBook2Look(isbn);
}

function initStaticFunctions() {
  if (window.staticProductData) {
    onStaticProductData(window.staticProductData);
  }

  window.addEventListener("supadu:staticProductData", (event) => {
    onStaticProductData(event.detail);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStaticFunctions);
} else {
  addRrpLabel();
  initStaticFunctions();
}